/* eslint-disable */
import { IUser } from "@/interfaces";
import { reactive, readonly, Ref, ref } from "vue";
import axios, { AxiosInstance } from 'axios';
import moment, { Moment } from "moment";
import mitt, { Emitter } from 'mitt'

/**
 * 日志全局托管方案
 * @returns 输出日志的函数console.log
 */
export function useLog(): (...info: any) => void {
    if (process.env.NODE_ENV === "development") {
        return console.log
    }
    else {
        return () => { }
    }
}

/**
 * 无视当前环境是否开发环境还是生产环境,强制输出日志
 * @returns 输出日志的函数console.log
 */
export function useForceLog(): (...info: any) => void {
    return console.log
}

/**
 * 全局数据托管方案
 * @returns {globalData:'全局数据',udpateXXX:'修改的方法'}
 */
// 数据
const globalData = reactive<{
    appName: string,
    nickname: string | null,
    nicknameLockStatus: boolean
}>({
    appName: '<坏123分享/>',
    nickname: '匿名游客',
    nicknameLockStatus: false
})
export function useGlobal() {

    // 修改当前游客昵称
    const updateNickname = (newNickname: string) => globalData.nickname = newNickname
    const updateNicknameAsync = async (newNickname: string) => globalData.nickname = newNickname

    // 修改游客昵称锁定状态
    const updateNicknameLockStatus = (newStatus: boolean) => globalData.nicknameLockStatus = newStatus
    const updateNicknameLockStatusAsync = async (newStatus: boolean) => globalData.nicknameLockStatus = newStatus

    return {
        globalData: readonly(globalData),
        updateNickname,
        updateNicknameAsync,
        updateNicknameLockStatus,
        updateNicknameLockStatusAsync
    }
}


// 延迟钩子
export function useDelay(millisecond = 1000): { isLoading: Ref<boolean> } {
    const isLoading = ref<boolean>(true)

    setTimeout(() => {
        isLoading.value = false
    }, millisecond);

    return {
        isLoading
    }
}


var instance = axios.create({ timeout: 1000 * 60 });
instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
// 发GET请求
export async function useGetRequest(url: string, params: any = {}): Promise<any> {
    return instance.get(url, { params })
}
// 发POST请求
export async function usePostRequest(url: string, data: any, config: any = {}): Promise<any> {
    return instance.post(url, data, config)
}
// 自己使用axios发请求
export function useAxios(): AxiosInstance {
    return instance
}

// 全局统一管理Moment
moment.locale('zh-cn')
export function useMoment(...args: any): Moment {
    return moment(...args)
}

// 全局托管消息事件总线
const emitter = mitt()
export function useMitt(): Emitter {
    return emitter
}